/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Dropdown, Image, InputNumber, Tag } from "antd";
import { useRef, useState } from "react";
import { DeleteIcon } from "../../../../../../../../atoms/CustomIcons";
import { MoreOutlined } from "@ant-design/icons";
import { PopUp } from "../../../../../../../../atoms/PopUp";
import ConfirmDelete from "../../../../../../../../atoms/ConfirmDelete";

export default function SimpleService(props: any) {
  const {
    serviceData,
    setGroupedData,
    visits,
    color,
    activeServiceLine,
    setActiveServiceLineId,
    setActiveRecord,
    setActiveServiceId,
    setActiveType,
    setSelectedServiceIds,
  } = props;
  const inHouse = serviceData?.who_performs === "in_house";
  const subContractor = serviceData?.who_performs === "sub_contractor";
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  // const [simpleServiceData, setSimpleServiceData] = useState({
  //   qty: 0,
  //   gm: 0,
  //   total_cost: 0,
  //   total_price: 0,
  // });

  // useEffect(() => {
  //   if (inputData.service_line_gm) {
  //     setSimpleServiceData((prevData: any) => ({
  //       ...prevData,
  //       gm: inputData.service_line_gm,
  //     }));
  //   }
  // }, [inputData]);

  // useEffect(() => {
  //   if (totalCost && totalPrice && setGroupedData) {
  //     // updateTotals?.(serviceData?.entity_id, totalCost, totalPrice);
  //     setGroupedData((prevData: any) => {
  //       return prevData.map((item: any) => {
  //         return {
  //           ...item,
  //           services:
  //             item?.services?.map((service: any) => {
  //               if (service?.entity_id === serviceData?.entity_id) {
  //                 return {
  //                   ...service,
  //                   total_cost: totalCost,
  //                   total_price: totalPrice,
  //                 };
  //               }

  //               return { ...service }; // Return the full service unchanged
  //             }) ?? [], // ensure fallback to empty array if services is undefined
  //         };
  //       });
  //     });
  //   }
  // }, [totalCost, totalPrice]);

  // useEffect(() => {
  //   if (simpleServiceData) {
  //     // updateTotals?.(serviceData?.entity_id, totalCost, totalPrice);
  //     setGroupedData((prevData: any) => {
  //       return prevData.map((item: any) => {
  //         return {
  //           ...item,
  //           services:
  //             item?.services?.map((service: any) => {
  //               if (service?.entity_id === serviceData?.entity_id) {
  //                 return {
  //                   ...service,
  //                   gross_margin_perc: +simpleServiceData?.gm || 0,
  //                   qty: simpleServiceData?.qty || 0,
  //                 };
  //               }

  //               return { ...service }; // Return the full service unchanged
  //             }) ?? [], // ensure fallback to empty array if services is undefined
  //         };
  //       });
  //     });
  //   }
  // }, [simpleServiceData]);

  // useEffect(() => {
  //   if (apiData?.length > 0) {
  //     setTimeout(() => {
  //       apiData?.forEach((serviceLine: any) => {
  //         if (serviceLine?.entity_id === serviceData.entity_id) {
  //           // setSimpleServiceData(() => ({
  //           //   qty: serviceLine?.qty || 0,
  //           //   gm: serviceLine?.gross_margin_perc || 0,
  //           //   total_cost: serviceLine?.total_cost || 0,
  //           //   total_price: serviceLine?.total_price || 0,
  //           // }));
  //         }
  //       });
  //     }, 1000);
  //   }
  // }, [apiData]);

  const serviceItems = [
    {
      key: "1",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/reset-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
          disabled={true}
        >
          Reset all service numbers to default
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setConfirmDelete(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          Remove service
        </Button>
      ),
    },
  ];

  const removeAllServiceTotals = () => {
    if (serviceData?.entity_id) {
      setSelectedServiceIds((prev: any) =>
        prev?.filter((id: any) => id !== serviceData?.entity_id)
      );
    }

    setGroupedData(
      (prevData: any) =>
        prevData
          .map((item: any) => {
            if (item.service_line_id === activeServiceLine?.service_line_id) {
              const updatedItem = {
                ...item,
                service_groups: item.service_groups || [],
                services: item.services.filter(
                  (service: any) => service.entity_id !== serviceData?.entity_id
                ),
              };

              // If both are empty, return null to filter later
              if (
                updatedItem.service_groups.length === 0 &&
                updatedItem.services.length === 0
              ) {
                return null;
              }

              return updatedItem;
            }
            return item;
          })
          .filter(Boolean) // remove nulls
    );
  };

  const deleteFunction = () => {
    setActiveRecord(null);
    setActiveType(null);
    setActiveServiceLineId(null);

    removeAllServiceTotals();
    setConfirmDelete(false);
  };

  const confirmDeleteService = {
    visibility: confirmDelete,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmDelete(false)}
        heading="Remove service from estimate"
        paragraph={
          <>
            This service will be removed from this estimate. <br />
            <br />
            Are you sure you want to remove it?
          </>
        }
        btnText="Remove service"
        btnApi={deleteFunction}
        loading={false}
        isArchivePopup={true}
      />
    ),
    width: 480,
    onCancel: () => setConfirmDelete(false),
  };

  console.log("serviceData", serviceData, visits);

  return (
    <Card
      className={`${color} estimateServicesList`}
      style={{ cursor: "pointer" }}
      onClick={() => {
        // setActiveId(serviceData?.entity_id);
        setActiveServiceLineId(activeServiceLine?.service_line_id);
        setActiveType("simple");
        setActiveRecord(serviceData);
        setActiveServiceId(serviceData?.entity_id);
      }}
    >
      <div className="top_wrap">
        <div className="top_wrap_left">
          <h4 style={{ marginBottom: "8px" }}>{serviceData?.name}</h4>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {inHouse && <img src="/images/estimate/tag_home.svg" alt="" />}
            {subContractor && (
              <img src="/images/estimate/tag_property.svg" alt="" />
            )}
            <Tag className="defaultTag default_tag">Complexity</Tag>
            {serviceData?.frequency !== "one_time" && (
              <Tag
                className={
                  serviceData?.visit > 0
                    ? "defaultTag default_tag purple_tag"
                    : "defaultTag default_tag yellow_tag"
                }
              >
                Visits: {serviceData?.visit}
              </Tag>
            )}
          </div>
        </div>

        <Card className="innerCard">
          <div className="innerCardBox">
            <p>Qty:</p>
            <h3
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <InputNumber
                placeholder="0"
                controls={false}
                value={serviceData?.qty || 0}
                addonAfter={
                  <span>{serviceData?.unit ? serviceData?.unit : ""}</span>
                }
                min={0}
                style={{
                  background: serviceData?.qty > 0 ? "transparent" : "#FFF9D9",
                }}
                // onClick={(e) => e.stopPropagation()}
                onChange={(newQty) => {
                  setGroupedData((prevData: any) => {
                    return prevData.map((serviceLine: any) => {
                      if (
                        serviceLine.service_line_id ===
                        activeServiceLine?.service_line_id
                      ) {
                        // ✅ update only services
                        const updatedServices = serviceLine.services.map(
                          (service: any) => {
                            if (service?.entity_id === serviceData?.entity_id) {
                              const HourPerVisit =
                                Number(newQty) / (service?.prod_rate || 1);

                              const unitCost =
                                serviceData?.material?.reduce(
                                  (sum: number, item: { unit_cost: number }) =>
                                    sum + (item.unit_cost || 0),
                                  0
                                ) || 0;

                              const useRate =
                                serviceData?.material?.reduce(
                                  (sum: number, item: { use_rate: number }) =>
                                    sum + (item.use_rate || 0),
                                  0
                                ) || 0;

                              const totalNeed = useRate
                                ? Number(newQty) / useRate
                                : 0;

                              const laborHrs =
                                Number(newQty) / (serviceData?.prod_rate || 1);

                              const totalLaborCost =
                                laborHrs * (activeServiceLine?.labor_rate || 0);

                              const totalMaterialCost =
                                totalNeed * unitCost || 0;

                              const totalCost =
                                totalLaborCost + totalMaterialCost;

                              const totalPrice = totalCost
                                ? (totalCost * 100) /
                                  (100 -
                                    (Number(serviceData?.gross_margin_perc) ||
                                      0))
                                : 0;

                              return {
                                ...service,
                                qty: Number(newQty),
                                hrs_per_visit: HourPerVisit,
                                total_cost: totalCost,
                                total_price: totalPrice,
                              };
                            }
                            return service;
                          }
                        );

                        // ✅ roll up totals from services
                        const servicesTotals = updatedServices.reduce(
                          (sum: any, s: any) => {
                            sum.cost += s.total_cost || 0;
                            sum.price += s.total_price || 0;
                            return sum;
                          },
                          { cost: 0, price: 0 }
                        );

                        // ✅ roll up totals from service_groups (unchanged, but must count)
                        const groupsTotals = serviceLine.service_groups?.reduce(
                          (sum: any, g: any) => {
                            g.services.forEach((svc: any) => {
                              sum.cost += svc.total_cost || 0;
                              sum.price += svc.total_price || 0;
                            });
                            return sum;
                          },
                          { cost: 0, price: 0 }
                        ) || { cost: 0, price: 0 };

                        const total_cost =
                          servicesTotals.cost + groupsTotals.cost;
                        const total_price =
                          servicesTotals.price + groupsTotals.price;

                        return {
                          ...serviceLine,
                          services: updatedServices,
                          total_cost,
                          total_price,
                        };
                      }
                      return serviceLine;
                    });
                  });
                }}
                className="serviceLineInput"
                formatter={(val) =>
                  `${val}`?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(val) => val?.replace(/\$\s?|(,*)/g, "") || ""}
              />
            </h3>
          </div>
          <div className="innerCardBox">
            <p>Total cost:</p>
            <h3>
              ${Number(serviceData?.total_cost?.toFixed(2)).toLocaleString()}
            </h3>
          </div>
          <div className="innerCardBox">
            <p>Total price:</p>
            <h3>
              ${Number(serviceData?.total_price?.toFixed(2)).toLocaleString()}
            </h3>
          </div>
          <div className="innerCardBox">
            <p>GM:</p>
            <h3
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <InputNumber
                value={serviceData?.gross_margin_perc}
                // onClick={(e) => e.stopPropagation()}
                style={{
                  background:
                    serviceData?.gross_margin_perc > 0
                      ? "transparent"
                      : "#FFF9D9",
                }}
                controls={false}
                min={0}
                onChange={(newGM) => {
                  setGroupedData((prevData: any) => {
                    return prevData.map((serviceLine: any) => {
                      if (
                        serviceLine.service_line_id ===
                        activeServiceLine?.service_line_id
                      ) {
                        // update services first
                        const updatedServices = serviceLine?.services.map(
                          (service: {
                            entity_id: string;
                            qty: number;
                            total_cost: number;
                          }) => {
                            if (service?.entity_id === serviceData?.entity_id) {
                              const totalPrice = serviceData?.total_cost
                                ? (serviceData?.total_cost * 100) /
                                  (100 - Number(newGM) || 0)
                                : 0;

                              return {
                                ...service,
                                gross_margin_perc: Number(newGM),
                                total_price: totalPrice,
                              };
                            }
                            return service;
                          }
                        );

                        const servicesTotals = updatedServices.reduce(
                          (sum: any, s: any) => {
                            sum.cost += s.total_cost || 0;
                            sum.price += s.total_price || 0;
                            return sum;
                          },
                          { cost: 0, price: 0 }
                        );

                        // ✅ roll up totals from service_groups (unchanged, but must count)
                        const groupsTotals = serviceLine.service_groups?.reduce(
                          (sum: any, g: any) => {
                            g.services.forEach((svc: any) => {
                              sum.cost += svc.total_cost || 0;
                              sum.price += svc.total_price || 0;
                            });
                            return sum;
                          },
                          { cost: 0, price: 0 }
                        ) || { cost: 0, price: 0 };

                        const total_price =
                          servicesTotals.price + groupsTotals.price;

                        return {
                          ...serviceLine,
                          services: updatedServices,
                          total_price,
                        };
                      }
                      return serviceLine;
                    });
                  });
                }}
                max={99}
                addonAfter={<span>%</span>}
                className="serviceLineInput"
              />
            </h3>
          </div>
        </Card>

        <div className="estimateDropdown">
          <Dropdown
            menu={{ items: serviceItems }}
            trigger={["click"]}
            placement="bottomRight"
            className="actionButton"
          >
            <Button
              onClick={(x) => {
                x.stopPropagation();
                // setServiceLineIdRecord(groupData?.service_line_id);
              }}
              onKeyDown={(e) => e.stopPropagation()}
              style={{
                padding: "0px",
                height: "36px",
                width: "36px",
                backgroundColor: "transparent",
                border: "1px solid #DEE5E6",
                borderRadius: "8px",
              }}
              className="only_icon"
              icon={<MoreOutlined />}
              ref={dropdownRef}
            />
          </Dropdown>
        </div>
      </div>
      <PopUp {...confirmDeleteService} />
    </Card>
  );
}
